'use client'

import { Alert, Button } from '@mui/material'
import { useTranslations } from 'next-intl'

import { classifyChatError } from './stream/transport'

type ChatErrorStateProps = {
  error: Error
  onRetry: () => void
}

/** A failed turn. Quota, credit and access failures explain themselves; the rest offer a retry. */
export default function ChatErrorState({ error, onRetry }: ChatErrorStateProps) {
  const t = useTranslations('features.AssistantV2')
  const failure = classifyChatError(error)

  if (failure === 'quota') {
    return (
      <Alert severity="warning" data-testid="assistant-quota-exceeded">
        {t('quotaExceeded')}
      </Alert>
    )
  }
  if (failure === 'credit') return <Alert severity="warning">{t('creditExhausted')}</Alert>
  if (failure === 'access') return <Alert severity="error">{t('accessDenied')}</Alert>

  return (
    <Alert
      severity="error"
      action={
        <Button color="inherit" size="small" onClick={onRetry}>
          {t('retry')}
        </Button>
      }
    >
      {failure === 'busy' ? t('turnInProgress') : t('errorGeneric')}
    </Alert>
  )
}
